export default {
	Varsity:'Varsity',
	Junior:'Junior Varsity'
}


// WEBPACK FOOTER //
// ./src/utils/constants/division.js